import React, { useContext } from 'react';
import { ConfiguratorContext } from '../../context/ConfiguratorProvider';

import { venueBadge, alt, location } from './badge.module.scss';

const Badge = ({ altClass, customClass, text = 'Preferred Vendor' }) => {
  const { isDev } = useContext(ConfiguratorContext);

  return (
    <>
      {isDev && <pre>Badge</pre>}
      <div
        className={`${venueBadge} ${altClass ? `${alt}` : ''} ${
          customClass ? location : ''
        }`}
      >
        <div>{text}</div>
      </div>
    </>
  );
};

export default Badge;
